import AntIconsRegister from './ant-icons-register';
export { default as AntIconsRegister } from './ant-icons-register';
var StepIcon = {
  install: function install(app) {
    app.use(AntIconsRegister);
  }
};
export default StepIcon;